// Temporary object mapping state fips to name

import { getRegionFromGeoid } from '@hyperobjekt/react-dashboard';

// TODO: put the state name in the tileset data so this is not needed.
export const FIPS_TO_STATE_NAME = {
  '01': 'Alabama',
  '02': 'Alaska',
  '04': 'Arizona',
  '05': 'Arkansas',
  '06': 'California',
  '08': 'Colorado',
  '09': 'Connecticut',
  10: 'Delaware',
  11: 'District of Columbia',
  12: 'Florida',
  13: 'Georgia',
  15: 'Hawaii',
  16: 'Idaho',
  17: 'Illinois',
  18: 'Indiana',
  19: 'Iowa',
  20: 'Kansas',
  21: 'Kentucky',
  22: 'Louisiana',
  23: 'Maine',
  24: 'Maryland',
  25: 'Massachusetts',
  26: 'Michigan',
  27: 'Minnesota',
  28: 'Mississippi',
  29: 'Missouri',
  30: 'Montana',
  31: 'Nebraska',
  32: 'Nevada',
  33: 'New Hampshire',
  34: 'New Jersey',
  35: 'New Mexico',
  36: 'New York',
  37: 'North Carolina',
  38: 'North Dakota',
  39: 'Ohio',
  40: 'Oklahoma',
  41: 'Oregon',
  42: 'Pennsylvania',
  44: 'Rhode Island',
  45: 'South Carolina',
  46: 'South Dakota',
  47: 'Tennessee',
  48: 'Texas',
  49: 'Utah',
  50: 'Vermont',
  51: 'Virginia',
  53: 'Washington',
  54: 'West Virginia',
  55: 'Wisconsin',
  56: 'Wyoming',
};

/**
 * Returns the name and parent location for a feature properties object
 * @param {object} featureProps
 * @returns
 */
export const getLocationNameParts = (featureProps) => {
  if (!featureProps) return null;
  const { name, state, GEOID } = featureProps;
  const region = getRegionFromGeoid(GEOID);
  const nameValue = name || featureProps.NAME || 'Unknown';
  const stateValue = state || featureProps.STATE;
  const parent = region === 'states' ? 'United States' : FIPS_TO_STATE_NAME[stateValue];
  return [nameValue, parent];
};

export const getColorForMetric = (metric) => {
  const category = metric.category || metric.id;
  switch (category) {
    case 'spi':
      return '#00afbd';
    case 'bhn':
      return '#00afbd';
    case 'fow':
      return '#f79445';
    case 'opp':
      return '#b6c469';
    default:
      return '#f5f5f5';
  }
};

export const GEOID_TO_PLACE_NAME = {
  '04000US01': 'Alabama',
  '04000US02': 'Alaska',
  '04000US04': 'Arizona',
  '04000US05': 'Arkansas',
  '04000US06': 'California',
  '04000US08': 'Colorado',
  '04000US09': 'Connecticut',
  '04000US10': 'Delaware',
  '04000US12': 'Florida',
  '04000US13': 'Georgia',
  '04000US15': 'Hawaii',
  '04000US16': 'Idaho',
  '04000US17': 'Illinois',
  '04000US18': 'Indiana',
  '04000US19': 'Iowa',
  '04000US20': 'Kansas',
  '04000US21': 'Kentucky',
  '04000US22': 'Louisiana',
  '04000US23': 'Maine',
  '04000US24': 'Maryland',
  '04000US25': 'Massachusetts',
  '04000US26': 'Michigan',
  '04000US27': 'Minnesota',
  '04000US28': 'Mississippi',
  '04000US29': 'Missouri',
  '04000US30': 'Montana',
  '04000US31': 'Nebraska',
  '04000US32': 'Nevada',
  '04000US33': 'New Hampshire',
  '04000US34': 'New Jersey',
  '04000US35': 'New Mexico',
  '04000US36': 'New York',
  '04000US37': 'North Carolina',
  '04000US38': 'North Dakota',
  '04000US39': 'Ohio',
  '04000US40': 'Oklahoma',
  '04000US41': 'Oregon',
  '04000US42': 'Pennsylvania',
  '04000US44': 'Rhode Island',
  '04000US45': 'South Carolina',
  '04000US46': 'South Dakota',
  '04000US47': 'Tennessee',
  '04000US48': 'Texas',
  '04000US49': 'Utah',
  '04000US50': 'Vermont',
  '04000US51': 'Virginia',
  '04000US53': 'Washington',
  '04000US54': 'West Virginia',
  '04000US55': 'Wisconsin',
  '04000US56': 'Wyoming',
  '16000US0107000': 'Birmingham, Alabama',
  '16000US0135896': 'Hoover, Alabama',
  '16000US0137000': 'Huntsville, Alabama',
  '16000US0150000': 'Mobile, Alabama',
  '16000US0151000': 'Montgomery, Alabama',
  '16000US0177256': 'Tuscaloosa, Alabama',
  '16000US0203000': 'Anchorage municipality, Alaska',
  '16000US0404720': 'Avondale, Arizona',
  '16000US0412000': 'Chandler, Arizona',
  '16000US0427400': 'Gilbert town, Arizona',
  '16000US0427820': 'Glendale, Arizona',
  '16000US0446000': 'Mesa, Arizona',
  '16000US0454050': 'Peoria, Arizona',
  '16000US0455000': 'Phoenix, Arizona',
  '16000US0465000': 'Scottsdale, Arizona',
  '16000US0471510': 'Surprise, Arizona',
  '16000US0473000': 'Tempe, Arizona',
  '16000US0477000': 'Tucson, Arizona',
  '16000US0485540': 'Yuma, Arizona',
  '16000US0523290': 'Fayetteville, Arkansas',
  '16000US0524550': 'Fort Smith, Arkansas',
  '16000US0535710': 'Jonesboro, Arkansas',
  '16000US0541000': 'Little Rock, Arkansas',
  '16000US0566080': 'Springdale, Arkansas',
  '16000US0600562': 'Alameda, California',
  '16000US0600884': 'Alhambra, California',
  '16000US0602000': 'Anaheim, California',
  '16000US0602252': 'Antioch, California',
  '16000US0602364': 'Apple Valley, California',
  '16000US0603526': 'Bakersfield, California',
  '16000US0603666': 'Baldwin Park, California',
  '16000US0604982': 'Bellflower, California',
  '16000US0606000': 'Berkeley, California',
  '16000US0608786': 'Buena Park, California',
  '16000US0608954': 'Burbank, California',
  '16000US0611194': 'Carlsbad, California',
  '16000US0611530': 'Carson, California',
  '16000US0613014': 'Chico, California',
  '16000US0613210': 'Chino, California',
  '16000US0613214': 'Chino Hills, California',
  '16000US0613392': 'Chula Vista, California',
  '16000US0613588': 'Citrus Heights, California',
  '16000US0614218': 'Clovis, California',
  '16000US0615044': 'Compton, California',
  '16000US0616000': 'Concord, California',
  '16000US0616350': 'Corona, California',
  '16000US0616532': 'Costa Mesa, California',
  '16000US0617918': 'Daly City, California',
  '16000US0619766': 'Downey, California',
  '16000US0621712': 'El Cajon, California',
  '16000US0622020': 'Elk Grove, California',
  '16000US0622230': 'El Monte, California',
  '16000US0622804': 'Escondido, California',
  '16000US0623182': 'Fairfield, California',
  '16000US0624638': 'Folsom, California',
  '16000US0624680': 'Fontana, California',
  '16000US0626000': 'Fremont, California',
  '16000US0627000': 'Fresno, California',
  '16000US0628000': 'Fullerton, California',
  '16000US0629000': 'Garden Grove, California',
  '16000US0630000': 'Glendale, California',
  '16000US0632548': 'Hawthorne, California',
  '16000US0633000': 'Hayward, California',
  '16000US0633182': 'Hemet, California',
  '16000US0633434': 'Hesperia, California',
  '16000US0636000': 'Huntington Beach, California',
  '16000US0636448': 'Indio, California',
  '16000US0636546': 'Inglewood, California',
  '16000US0636770': 'Irvine, California',
  '16000US0639496': 'Lake Forest, California',
  '16000US0639892': 'Lakewood, California',
  '16000US0640130': 'Lancaster, California',
  '16000US0641992': 'Livermore, California',
  '16000US0643000': 'Long Beach, California',
  '16000US0644000': 'Los Angeles, California',
  '16000US0644574': 'Lynwood, California',
  '16000US0645484': 'Manteca, California',
  '16000US0646842': 'Menifee, California',
  '16000US0646898': 'Merced, California',
  '16000US0647766': 'Milpitas, California',
  '16000US0648256': 'Mission Viejo, California',
  '16000US0648354': 'Modesto, California',
  '16000US0649270': 'Moreno Valley, California',
  '16000US0649670': 'Mountain View, California',
  '16000US0650076': 'Murrieta, California',
  '16000US0650258': 'Napa, California',
  '16000US0651182': 'Newport Beach, California',
  '16000US0652526': 'Norwalk, California',
  '16000US0653000': 'Oakland, California',
  '16000US0653322': 'Oceanside, California',
  '16000US0653896': 'Ontario, California',
  '16000US0653980': 'Orange, California',
  '16000US0654652': 'Oxnard, California',
  '16000US0655156': 'Palmdale, California',
  '16000US0656000': 'Pasadena, California',
  '16000US0656700': 'Perris, California',
  '16000US0657792': 'Pleasanton, California',
  '16000US0658072': 'Pomona, California',
  '16000US0659451': 'Rancho Cucamonga, California',
  '16000US0659920': 'Redding, California',
  '16000US0659962': 'Redlands, California',
  '16000US0660018': 'Redondo Beach, California',
  '16000US0660102': 'Redwood City, California',
  '16000US0660466': 'Rialto, California',
  '16000US0660620': 'Richmond, California',
  '16000US0662000': 'Riverside, California',
  '16000US0662938': 'Roseville, California',
  '16000US0664000': 'Sacramento, California',
  '16000US0664224': 'Salinas, California',
  '16000US0665000': 'San Bernardino, California',
  '16000US0665042': 'San Buenaventura (Ventura), California',
  '16000US0666000': 'San Diego, California',
  '16000US0667000': 'San Francisco, California',
  '16000US0668000': 'San Jose, California',
  '16000US0668084': 'San Leandro, California',
  '16000US0668196': 'San Marcos, California',
  '16000US0668252': 'San Mateo, California',
  '16000US0668378': 'San Ramon, California',
  '16000US0669000': 'Santa Ana, California',
  '16000US0669070': 'Santa Barbara, California',
  '16000US0669084': 'Santa Clara, California',
  '16000US0669088': 'Santa Clarita, California',
  '16000US0669196': 'Santa Maria, California',
  '16000US0670000': 'Santa Monica, California',
  '16000US0670098': 'Santa Rosa, California',
  '16000US0672016': 'Simi Valley, California',
  '16000US0673080': 'South Gate, California',
  '16000US0675000': 'Stockton, California',
  '16000US0677000': 'Sunnyvale, California',
  '16000US0678120': 'Temecula, California',
  '16000US0678582': 'Thousand Oaks, California',
  '16000US0680000': 'Torrance, California',
  '16000US0680238': 'Tracy, California',
  '16000US0680812': 'Turlock, California',
  '16000US0680854': 'Tustin, California',
  '16000US0681204': 'Union City, California',
  '16000US0681344': 'Upland, California',
  '16000US0681554': 'Vacaville, California',
  '16000US0681666': 'Vallejo, California',
  '16000US0682590': 'Victorville, California',
  '16000US0682954': 'Visalia, California',
  '16000US0682996': 'Vista, California',
  '16000US0684200': 'West Covina, California',
  '16000US0684550': 'Westminster, California',
  '16000US0685292': 'Whittier, California',
  '16000US0803455': 'Arvada, Colorado',
  '16000US0804000': 'Aurora, Colorado',
  '16000US0807850': 'Boulder, Colorado',
  '16000US0812815': 'Centennial, Colorado',
  '16000US0816000': 'Colorado Springs, Colorado',
  '16000US0820000': 'Denver, Colorado',
  '16000US0827425': 'Fort Collins, Colorado',
  '16000US0832155': 'Greeley, Colorado',
  '16000US0843000': 'Lakewood, Colorado',
  '16000US0845970': 'Longmont, Colorado',
  '16000US0846465': 'Loveland, Colorado',
  '16000US0862000': 'Pueblo, Colorado',
  '16000US0877290': 'Thornton, Colorado',
  '16000US0883835': 'Westminster, Colorado',
  '16000US0908000': 'Bridgeport, Connecticut',
  '16000US0918430': 'Danbury, Connecticut',
  '16000US0937000': 'Hartford, Connecticut',
  '16000US0950370': 'New Britain, Connecticut',
  '16000US0952000': 'New Haven, Connecticut',
  '16000US0955990': 'Norwalk, Connecticut',
  '16000US0973000': 'Stamford, Connecticut',
  '16000US0980000': 'Waterbury, Connecticut',
  '16000US1077580': 'Wilmington, Delaware',
  '16000US1150000': 'Washington, District of Columbia',
  '16000US1207300': 'Boca Raton, Florida',
  '16000US1207875': 'Boynton Beach, Florida',
  '16000US1210275': 'Cape Coral, Florida',
  '16000US1212875': 'Clearwater, Florida',
  '16000US1214400': 'Coral Springs, Florida',
  '16000US1216475': 'Davie town, Florida',
  '16000US1216725': 'Deerfield Beach, Florida',
  '16000US1217200': 'Deltona, Florida',
  '16000US1224000': 'Fort Lauderdale, Florida',
  '16000US1225175': 'Gainesville, Florida',
  '16000US1230000': 'Hialeah, Florida',
  '16000US1232000': 'Hollywood, Florida',
  '16000US1235000': 'Jacksonville, Florida',
  '16000US1238250': 'Lakeland, Florida',
  '16000US1239425': 'Largo, Florida',
  '16000US1239550': 'Lauderhill, Florida',
  '16000US1243975': 'Melbourne, Florida',
  '16000US1245000': 'Miami, Florida',
  '16000US1245025': 'Miami Beach, Florida',
  '16000US1245060': 'Miami Gardens, Florida',
  '16000US1245975': 'Miramar, Florida',
  '16000US1253000': 'Orlando, Florida',
  '16000US1254000': 'Palm Bay, Florida',
  '16000US1254200': 'Palm Coast, Florida',
  '16000US1255775': 'Pembroke Pines, Florida',
  '16000US1257425': 'Plantation, Florida',
  '16000US1258050': 'Pompano Beach, Florida',
  '16000US1258715': 'Port St. Lucie, Florida',
  '16000US1263000': 'St. Petersburg, Florida',
  '16000US1269700': 'Sunrise, Florida',
  '16000US1270600': 'Tallahassee, Florida',
  '16000US1271000': 'Tampa, Florida',
  '16000US1276600': 'West Palm Beach, Florida',
  '16000US1301052': 'Albany, Georgia',
  '16000US1303440': 'Athens-Clarke County Unified Government (balance), Georgia',
  '16000US1304000': 'Atlanta, Georgia',
  '16000US1304204': 'Augusta-Richmond County Consolidated Government (balance), Georgia',
  '16000US1319000': 'Columbus, Georgia',
  '16000US1342425': 'Johns Creek, Georgia',
  '16000US1349008': 'Macon-Bibb County, Georgia',
  '16000US1367284': 'Roswell, Georgia',
  '16000US1368516': 'Sandy Springs, Georgia',
  '16000US1369000': 'Savannah, Georgia',
  '16000US1380508': 'Warner Robins, Georgia',
  '16000US1571550': 'Urban Honolulu CDP, Hawaii',
  '16000US1608830': 'Boise City, Idaho',
  '16000US1652120': 'Meridian, Idaho',
  '16000US1656260': 'Nampa, Idaho',
  '16000US1702154': 'Arlington Heights village, Illinois',
  '16000US1703012': 'Aurora, Illinois',
  '16000US1706613': 'Bloomington, Illinois',
  '16000US1707133': 'Bolingbrook village, Illinois',
  '16000US1712385': 'Champaign, Illinois',
  '16000US1714000': 'Chicago, Illinois',
  '16000US1714351': 'Cicero town, Illinois',
  '16000US1718823': 'Decatur, Illinois',
  '16000US1723074': 'Elgin, Illinois',
  '16000US1724582': 'Evanston, Illinois',
  '16000US1738570': 'Joliet, Illinois',
  '16000US1751622': 'Naperville, Illinois',
  '16000US1757225': 'Palatine village, Illinois',
  '16000US1759000': 'Peoria, Illinois',
  '16000US1765000': 'Rockford, Illinois',
  '16000US1768003': 'Schaumburg village, Illinois',
  '16000US1772000': 'Springfield, Illinois',
  '16000US1779293': 'Waukegan, Illinois',
  '16000US1805860': 'Bloomington, Indiana',
  '16000US1810342': 'Carmel, Indiana',
  '16000US1822000': 'Evansville, Indiana',
  '16000US1823278': 'Fishers, Indiana',
  '16000US1825000': 'Fort Wayne, Indiana',
  '16000US1827000': 'Gary, Indiana',
  '16000US1831000': 'Hammond, Indiana',
  '16000US1836003': 'Indianapolis (balance), Indiana',
  '16000US1840788': 'Lafayette, Indiana',
  '16000US1851876': 'Muncie, Indiana',
  '16000US1871000': 'South Bend, Indiana',
  '16000US1912000': 'Cedar Rapids, Iowa',
  '16000US1919000': 'Davenport, Iowa',
  '16000US1921000': 'Des Moines, Iowa',
  '16000US1938595': 'Iowa City, Iowa',
  '16000US1973335': 'Sioux City, Iowa',
  '16000US1982425': 'Waterloo, Iowa',
  '16000US2036000': 'Kansas City, Kansas',
  '16000US2038900': 'Lawrence, Kansas',
  '16000US2052575': 'Olathe, Kansas',
  '16000US2053775': 'Overland Park, Kansas',
  '16000US2071000': 'Topeka, Kansas',
  '16000US2079000': 'Wichita, Kansas',
  '16000US2146027': 'Lexington-Fayette Urban County, Kentucky',
  '16000US2148006': 'Louisville/Jefferson County Metro Government (balance), Kentucky',
  '16000US2205000': 'Baton Rouge, Louisiana',
  '16000US2239475': 'Kenner, Louisiana',
  '16000US2240735': 'Lafayette, Louisiana',
  '16000US2241155': 'Lake Charles, Louisiana',
  '16000US2255000': 'New Orleans, Louisiana',
  '16000US2270000': 'Shreveport, Louisiana',
  '16000US2360545': 'Portland, Maine',
  '16000US2404000': 'Baltimore, Maryland',
  '16000US2507000': 'Boston, Massachusetts',
  '16000US2509000': 'Brockton, Massachusetts',
  '16000US2511000': 'Cambridge, Massachusetts',
  '16000US2523000': 'Fall River, Massachusetts',
  '16000US2534550': 'Lawrence, Massachusetts',
  '16000US2537000': 'Lowell, Massachusetts',
  '16000US2537490': 'Lynn, Massachusetts',
  '16000US2545000': 'New Bedford, Massachusetts',
  '16000US2545560': 'Newton, Massachusetts',
  '16000US2555745': 'Quincy, Massachusetts',
  '16000US2562535': 'Somerville, Massachusetts',
  '16000US2567000': 'Springfield, Massachusetts',
  '16000US2582000': 'Worcester, Massachusetts',
  '16000US2603000': 'Ann Arbor, Michigan',
  '16000US2621000': 'Dearborn, Michigan',
  '16000US2622000': 'Detroit, Michigan',
  '16000US2627440': 'Farmington Hills, Michigan',
  '16000US2629000': 'Flint, Michigan',
  '16000US2634000': 'Grand Rapids, Michigan',
  '16000US2642160': 'Kalamazoo, Michigan',
  '16000US2646000': 'Lansing, Michigan',
  '16000US2649000': 'Livonia, Michigan',
  '16000US2669035': 'Rochester Hills, Michigan',
  '16000US2674900': 'Southfield, Michigan',
  '16000US2676460': 'Sterling Heights, Michigan',
  '16000US2680700': 'Troy, Michigan',
  '16000US2684000': 'Warren, Michigan',
  '16000US2686000': 'Westland, Michigan',
  '16000US2688940': 'Wyoming, Michigan',
  '16000US2706616': 'Bloomington, Minnesota',
  '16000US2707966': 'Brooklyn Park, Minnesota',
  '16000US2717000': 'Duluth, Minnesota',
  '16000US2743000': 'Minneapolis, Minnesota',
  '16000US2751730': 'Plymouth, Minnesota',
  '16000US2754880': 'Rochester, Minnesota',
  '16000US2758000': 'St. Paul, Minnesota',
  '16000US2829700': 'Gulfport, Mississippi',
  '16000US2836000': 'Jackson, Mississippi',
  '16000US2915670': 'Columbia, Missouri',
  '16000US2935000': 'Independence, Missouri',
  '16000US2938000': 'Kansas City, Missouri',
  '16000US2941348': "Lee's Summit, Missouri",
  '16000US2954074': "O'Fallon, Missouri",
  '16000US2964550': 'St. Joseph, Missouri',
  '16000US2965000': 'St. Louis, Missouri',
  '16000US2970000': 'Springfield, Missouri',
  '16000US3006550': 'Billings, Montana',
  '16000US3050200': 'Missoula, Montana',
  '16000US3128000': 'Lincoln, Nebraska',
  '16000US3137000': 'Omaha, Nebraska',
  '16000US3231900': 'Henderson, Nevada',
  '16000US3240000': 'Las Vegas, Nevada',
  '16000US3251800': 'North Las Vegas, Nevada',
  '16000US3260600': 'Reno, Nevada',
  '16000US3268400': 'Sparks, Nevada',
  '16000US3345140': 'Manchester, New Hampshire',
  '16000US3350260': 'Nashua, New Hampshire',
  '16000US3410000': 'Camden, New Jersey',
  '16000US3413690': 'Clifton, New Jersey',
  '16000US3421000': 'Elizabeth, New Jersey',
  '16000US3436000': 'Jersey City, New Jersey',
  '16000US3451000': 'Newark, New Jersey',
  '16000US3456550': 'Passaic, New Jersey',
  '16000US3457000': 'Paterson, New Jersey',
  '16000US3474000': 'Trenton, New Jersey',
  '16000US3474630': 'Union City, New Jersey',
  '16000US3502000': 'Albuquerque, New Mexico',
  '16000US3539380': 'Las Cruces, New Mexico',
  '16000US3563460': 'Rio Rancho, New Mexico',
  '16000US3570500': 'Santa Fe, New Mexico',
  '16000US3601000': 'Albany, New York',
  '16000US3611000': 'Buffalo, New York',
  '16000US3649121': 'Mount Vernon, New York',
  '16000US3650617': 'New Rochelle, New York',
  '16000US3651000': 'New York, New York',
  '16000US3663000': 'Rochester, New York',
  '16000US3665508': 'Schenectady, New York',
  '16000US3673000': 'Syracuse, New York',
  '16000US3684000': 'Yonkers, New York',
  '16000US3702140': 'Asheville, North Carolina',
  '16000US3710740': 'Cary town, North Carolina',
  '16000US3712000': 'Charlotte, North Carolina',
  '16000US3714100': 'Concord, North Carolina',
  '16000US3719000': 'Durham, North Carolina',
  '16000US3722920': 'Fayetteville, North Carolina',
  '16000US3725580': 'Gastonia, North Carolina',
  '16000US3728000': 'Greensboro, North Carolina',
  '16000US3728080': 'Greenville, North Carolina',
  '16000US3731400': 'High Point, North Carolina',
  '16000US3734200': 'Jacksonville, North Carolina',
  '16000US3755000': 'Raleigh, North Carolina',
  '16000US3774440': 'Wilmington, North Carolina',
  '16000US3775000': 'Winston-Salem, North Carolina',
  '16000US3825700': 'Fargo, North Dakota',
  '16000US3901000': 'Akron, Ohio',
  '16000US3912000': 'Canton, Ohio',
  '16000US3915000': 'Cincinnati, Ohio',
  '16000US3916000': 'Cleveland, Ohio',
  '16000US3918000': 'Columbus, Ohio',
  '16000US3921000': 'Dayton, Ohio',
  '16000US3961000': 'Parma, Ohio',
  '16000US3977000': 'Toledo, Ohio',
  '16000US3988000': 'Youngstown, Ohio',
  '16000US4009050': 'Broken Arrow, Oklahoma',
  '16000US4023200': 'Edmond, Oklahoma',
  '16000US4041850': 'Lawton, Oklahoma',
  '16000US4052500': 'Norman, Oklahoma',
  '16000US4055000': 'Oklahoma City, Oklahoma',
  '16000US4075000': 'Tulsa, Oklahoma',
  '16000US4105350': 'Beaverton, Oregon',
  '16000US4105800': 'Bend, Oregon',
  '16000US4123850': 'Eugene, Oregon',
  '16000US4131250': 'Gresham, Oregon',
  '16000US4134100': 'Hillsboro, Oregon',
  '16000US4147000': 'Medford, Oregon',
  '16000US4159000': 'Portland, Oregon',
  '16000US4164900': 'Salem, Oregon',
  '16000US4202000': 'Allentown, Pennsylvania',
  '16000US4206088': 'Bethlehem, Pennsylvania',
  '16000US4224000': 'Erie, Pennsylvania',
  '16000US4260000': 'Philadelphia, Pennsylvania',
  '16000US4261000': 'Pittsburgh, Pennsylvania',
  '16000US4263624': 'Reading, Pennsylvania',
  '16000US4269000': 'Scranton, Pennsylvania',
  '16000US4419180': 'Cranston, Rhode Island',
  '16000US4454640': 'Pawtucket, Rhode Island',
  '16000US4459000': 'Providence, Rhode Island',
  '16000US4474300': 'Warwick, Rhode Island',
  '16000US4513330': 'Charleston, South Carolina',
  '16000US4516000': 'Columbia, South Carolina',
  '16000US4548535': 'Mount Pleasant town, South Carolina',
  '16000US4550875': 'North Charleston, South Carolina',
  '16000US4561405': 'Rock Hill, South Carolina',
  '16000US4652980': 'Rapid City, South Dakota',
  '16000US4659020': 'Sioux Falls, South Dakota',
  '16000US4714000': 'Chattanooga, Tennessee',
  '16000US4715160': 'Clarksville, Tennessee',
  '16000US4740000': 'Knoxville, Tennessee',
  '16000US4748000': 'Memphis, Tennessee',
  '16000US4751560': 'Murfreesboro, Tennessee',
  '16000US4752006': 'Nashville-Davidson Metropolitan Government (balance), Tennessee',
  '16000US4801000': 'Abilene, Texas',
  '16000US4801924': 'Allen, Texas',
  '16000US4803000': 'Amarillo, Texas',
  '16000US4804000': 'Arlington, Texas',
  '16000US4805000': 'Austin, Texas',
  '16000US4806128': 'Baytown, Texas',
  '16000US4807000': 'Beaumont, Texas',
  '16000US4810768': 'Brownsville, Texas',
  '16000US4810912': 'Bryan, Texas',
  '16000US4813024': 'Carrollton, Texas',
  '16000US4815976': 'College Station, Texas',
  '16000US4817000': 'Corpus Christi, Texas',
  '16000US4819000': 'Dallas, Texas',
  '16000US4819972': 'Denton, Texas',
  '16000US4822660': 'Edinburg, Texas',
  '16000US4824000': 'El Paso, Texas',
  '16000US4827000': 'Fort Worth, Texas',
  '16000US4827684': 'Frisco, Texas',
  '16000US4829000': 'Garland, Texas',
  '16000US4830464': 'Grand Prairie, Texas',
  '16000US4835000': 'Houston, Texas',
  '16000US4837000': 'Irving, Texas',
  '16000US4839148': 'Killeen, Texas',
  '16000US4841464': 'Laredo, Texas',
  '16000US4841980': 'League City, Texas',
  '16000US4842508': 'Lewisville, Texas',
  '16000US4843888': 'Longview, Texas',
  '16000US4845000': 'Lubbock, Texas',
  '16000US4845384': 'McAllen, Texas',
  '16000US4845744': 'McKinney, Texas',
  '16000US4847892': 'Mesquite, Texas',
  '16000US4848072': 'Midland, Texas',
  '16000US4848768': 'Mission, Texas',
  '16000US4848804': 'Missouri City, Texas',
  '16000US4853388': 'Odessa, Texas',
  '16000US4856000': 'Pasadena, Texas',
  '16000US4856348': 'Pearland, Texas',
  '16000US4857200': 'Pharr, Texas',
  '16000US4858016': 'Plano, Texas',
  '16000US4861796': 'Richardson, Texas',
  '16000US4863500': 'Round Rock, Texas',
  '16000US4864472': 'San Angelo, Texas',
  '16000US4865000': 'San Antonio, Texas',
  '16000US4870808': 'Sugar Land, Texas',
  '16000US4874144': 'Tyler, Texas',
  '16000US4876000': 'Waco, Texas',
  '16000US4879000': 'Wichita Falls, Texas',
  '16000US4943660': 'Layton, Utah',
  '16000US4955980': 'Ogden, Utah',
  '16000US4957300': 'Orem, Utah',
  '16000US4962470': 'Provo, Utah',
  '16000US4965330': 'St. George, Utah',
  '16000US4967000': 'Salt Lake City, Utah',
  '16000US4967440': 'Sandy, Utah',
  '16000US4982950': 'West Jordan, Utah',
  '16000US4983470': 'West Valley City, Utah',
  '16000US5010675': 'Burlington, Vermont',
  '16000US5101000': 'Alexandria, Virginia',
  '16000US5116000': 'Chesapeake, Virginia',
  '16000US5135000': 'Hampton, Virginia',
  '16000US5147672': 'Lynchburg, Virginia',
  '16000US5156000': 'Newport News, Virginia',
  '16000US5157000': 'Norfolk, Virginia',
  '16000US5164000': 'Portsmouth, Virginia',
  '16000US5167000': 'Richmond, Virginia',
  '16000US5168000': 'Roanoke, Virginia',
  '16000US5176432': 'Suffolk, Virginia',
  '16000US5182000': 'Virginia Beach, Virginia',
  '16000US5303180': 'Auburn, Washington',
  '16000US5305210': 'Bellevue, Washington',
  '16000US5305280': 'Bellingham, Washington',
  '16000US5322640': 'Everett, Washington',
  '16000US5323515': 'Federal Way, Washington',
  '16000US5335275': 'Kennewick, Washington',
  '16000US5335415': 'Kent, Washington',
  '16000US5357745': 'Renton, Washington',
  '16000US5363000': 'Seattle, Washington',
  '16000US5367000': 'Spokane, Washington',
  '16000US5367167': 'Spokane Valley, Washington',
  '16000US5370000': 'Tacoma, Washington',
  '16000US5374060': 'Vancouver, Washington',
  '16000US5380010': 'Yakima, Washington',
  '16000US5414600': 'Charleston, West Virginia',
  '16000US5502375': 'Appleton, Wisconsin',
  '16000US5531000': 'Green Bay, Wisconsin',
  '16000US5539225': 'Kenosha, Wisconsin',
  '16000US5548000': 'Madison, Wisconsin',
  '16000US5553000': 'Milwaukee, Wisconsin',
  '16000US5566000': 'Racine, Wisconsin',
  '16000US5584250': 'Waukesha, Wisconsin',
  '16000US5613900': 'Cheyenne, Wyoming',
};
